import angular from 'angular';

angular
    .module('epdf.admin.activities')

    .factory('ActivityService', [
        '$resource',
        'API_CONFIG',
        function($resource, API_CONFIG) {
            var Activity = $resource(
                API_CONFIG.url + '/v1/activities',
                {},
                {
                    // Recherche toutes les activités ainsi que leurs statuts
                    findAll: {
                        method: 'GET',
                        isArray: true
                    },
                    // Change le statut d'une activité
                    changeActivityStatus: {
                        method: 'POST',
                        url: API_CONFIG.url + '/v1/activities/changeActivityStatus'
                    }
                }
            );

            return Activity;
        }
    ]);
